

<div *ngIf="!isMatrix">
  <div class="row p-2" style="display: flex;justify-content: space-between;">
    <div *ngIf="showName" class="mat-body-1 displayFlex" [ngClass]="{'col-md-7':!IsConsentScreen,'col-md-10':IsConsentScreen}">
      <span *ngIf="!IsConsentScreen" [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span *ngIf="IsConsentScreen" [innerHTML]="question.consentQuestionLabel || question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
    </div>
    <div class="mat-body-1" [ngClass]="{'col-md-4': showName && !IsConsentScreen,'col-md':IsConsentScreen}">   
      <div *ngIf="question.options.length > 0">
        <div *ngFor="let option of question.options;let k = index;" [ngClass]="{'readOnly':IsReadOnly, 'gridChk':!showName}">            
        <mat-checkbox color="primary"
          [checked]="option.selected"          
          [hidden]="option.isQuesOptionVisible==false" 
          [disableRipple]="true"
          (click)="onCheckBoxClick($event, option.value, k)"
          [value]="option.value"> 
          {{option.value}}
        </mat-checkbox>
      </div>
      </div>  
    </div>
  </div>
</div>
<div *ngIf="errormgvisible" class="offset-8">
  <div class="errormsg mat-body-1 margin-top" *ngFor="let error of validationerrormessage">{{error}}</div>
</div>

